module.exports = __webpack_public_path__ + "static/media/centros-medicos-new.80991d79.jpg";